export default __webpack_public_path__ + "static/media/loader.10a958f0.svg";